import { environment } from '@env/environment';

/**
 * The leading path segment when it is an explicit supported-language prefix,
 * otherwise undefined (callers fall back to the default language).
 */
function langHead(segments: string[]): string | undefined {
    const head = segments[0]?.toLowerCase();
    return head && environment.supportedLanguages.includes(head) ? head : undefined;
}

/**
 * True when the URL path carries an explicit supported-language prefix, as
 * opposed to splitLangPrefix's defaulted language when none is present.
 */
export function hasLangPrefix(segments: string[]): boolean {
    return langHead(segments) !== undefined;
}

/**
 * Splits URL path segments into the leading language prefix and the rest.
 * If the first segment is a supported language it is the active language,
 * otherwise the default language is assumed and no prefix is consumed.
 */
export function splitLangPrefix(segments: string[]): { lang: string; rest: string[] } {
    const head = langHead(segments);
    return head ? { lang: head, rest: segments.slice(1) } : { lang: environment.defaultLanguage, rest: segments };
}
